import { buildReferralFormSchema } from '../../../../common';
import { REFERRAL_CITY_MIN_LENGTH, REFERRAL_PROVIDER_NAME_MIN_LENGTH } from './constants';

export const REFERRAL_FORM_SCHEMA = buildReferralFormSchema({
  providerNameMinLength: REFERRAL_PROVIDER_NAME_MIN_LENGTH,
  cityMinLength: REFERRAL_CITY_MIN_LENGTH,
});
